import React from "react";
import useIsMobile from "../../common/hooks/useIsMobile";

function Icon() {
  const isMobile = useIsMobile()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={!isMobile ? "10vw": "36vw"}
      height={!isMobile ? "10vw": "36vw"}
      fill="none"
      viewBox="0 0 165 149"
    >
      <path
        stroke="#575757"
        strokeWidth="2"
        d="M156.5 44.7v1h7.5v94.85h-7.5V148H8.5v-7.45H1V8.45h7.5V1H149v7.45h7.5v12.9h-135v16.9h135v6.45zM150 97.85h1v-16.9h-7.5V73.5h-17v7.45H119v16.9h7.5v7.45h17v-7.45h6.5z"
      ></path>
    </svg>
  );
}

export default Icon;
